import Vue from 'vue'
import Router from 'vue-router'


import homepage from '@/views/website/default'
import about from '@/views/website/about'
import gallery from '@/views/website/gallery'
import faq from '@/views/website/faq'
import contact from '@/views/website/contact'

import services from '@/views/website/services/listing'
import serviceSingle from '@/views/website/services/single'

import requestQuotation from '@/views/website/request-quotation'

import loginCustomer from '@/views/website/customer/login'
import dashboardCustomer from '@/views/website/customer/dashboard'
import factureCustomer from '@/views/website/customer/facture'

import dashboard from '@/views/dashboard/dashboard'
import newFolder from '@/views/dashboard/dossier/new'
import listingFolder from '@/views/dashboard/dossier/listing'
import updateFolder from '@/views/dashboard/dossier/update'
import singleFolder from '@/views/dashboard/dossier/single'
import singleFolderFacture from '@/views/dashboard/dossier/facture/listing'

import dashboardMessages from '@/views/dashboard/message/listing'

import listingCustomer from '@/views/dashboard/customer/listing'

import listingFacture from '@/views/dashboard/facture/listing'

import databaseListing from '@/views/dashboard/database/listing'

import dashboardLogin from '@/views/dashboard/login/login'
import resetLogin from '@/views/dashboard/login/reset'
import checkResetLogin from '@/views/dashboard/login/check.reset'

import myProfile from '@/views/dashboard/users/profile'
import usersPrivilege from '@/views/dashboard/users/privilege'
import usersListing from '@/views/dashboard/users/listing'

import settings from '@/views/dashboard/settings/index'

import statistics from '@/views/dashboard/statistics/index'

import websiteSettings from '@/views/dashboard/website/settings'

import notAllowed from '@/views/dashboard/commons/notAllowed'
import comingSoon from '@/views/website/commons/comingSoon'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/not-allowed',
      name:'notAllowed',
      component: notAllowed,
      meta: {layout: 'default', allowAnonymous: true, title: '403 - Prime Shipping Agency' }
    },
    {
      path: '/coming-soon',
      name:'comingSoon',
      component: comingSoon,
      meta: {layout: 'default', allowAnonymous: true }
    },
    {
      path: '/',
      name: 'Website',
      component: homepage,
      meta: { layout: 'default', allowAnonymous: true }
    },
    {
      path: '/about',
      name: 'About',
      component: about,
      meta: { layout: 'default', allowAnonymous: true }
    },
    {
      path: '/faq',
      name: 'FAQ',
      component: faq,
      meta: { layout: 'default', allowAnonymous: true }
    },
    {
      path: '/gallery',
      name: 'Gallery',
      component: gallery,
      meta: { layout: 'default', allowAnonymous: true }
    },
    {
      path: '/services',
      name: 'Services',
      component: services,
      meta: { layout: 'default', allowAnonymous: true }
    },
    {
      path: '/request-quotation',
      name: 'requestQuotation',
      component: requestQuotation,
      meta: { layout: 'default', allowAnonymous: true }
    },
    {
      path: '/services/:name',
      name: 'singleService',
      component: serviceSingle,
      meta: { layout: 'default', allowAnonymous: true }
    },
    {
      path: '/contact',
      name: 'Contact',
      component: contact,
      meta: { layout: 'default', allowAnonymous: true }
    },
    {
      path: '/login-customer',
      name: 'loginCustomer',
      component: loginCustomer,
      meta: { layout: 'default', allowAnonymous: true}
    },
    {
      path: '/customer/dashboard',
      name: 'dashboardCustomer',
      component: dashboardCustomer,
      meta: { layout: 'default', allowAnonymous: false}
    },
    {
      path: '/customer/dashboard/factures',
      name: 'factureCustomer',
      component: factureCustomer,
      meta: { layout: 'default', allowAnonymous: false}
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      redirect: { name: 'dashboardHome' },
      meta: { layout: 'dashboard', permissions: [], allowAnonymous: false }
    },
    {
      path: '/dashboard/home',
      name: 'dashboardHome',
      component: dashboard,
      meta: { layout: 'dashboard', permissions: [], allowAnonymous: false }
    },
    {
      path: '/dashboard/messages',
      name: 'dashboardMessages',
      component: dashboardMessages,
      meta: { layout: 'dashboard', permissions: [], allowAnonymous: false }
    },
    {
      path: '/dashboard/facture',
      name: 'listingFacture',
      component: listingFacture,
      meta: { layout: 'dashboard', permissions: ['browse_facture'], allowAnonymous: false }
    },
    {
      path: '/dashboard/customers',
      name: 'listingCustomer',
      component: listingCustomer,
      meta: { layout: 'dashboard', permissions: ['browse_client'], allowAnonymous: false }
    },
    {
      path: '/dashboard/dossier/nouveau',
      name: 'newFolder',
      component: newFolder,
      meta: {layout: 'dashboard', permissions: ['add_dossier'], allowAnonymous: false}
    },
    {
      path: '/dashboard/dossier',
      name: 'listingFolder',
      component: listingFolder,
      meta: {layout: 'dashboard', permissions: ['browse_dossier'], allowAnonymous: false}
    },
    {
      path: '/dashboard/dossier/listing',
      name: 'listingFolderGeneral',
      component: listingFolder,
      meta: {layout: 'dashboard', permissions: ['browse_dossier'], allowAnonymous: false}
    },
    {
      path: '/dashboard/dossier/update/:id',
      name: 'updateFolder',
      component: updateFolder,
      meta: {layout: 'dashboard', permissions: ['edit_dossier'], allowAnonymous: false}
    },
    {
      path: '/dashboard/dossier/:id',
      name: 'singleFolder',
      component: singleFolder,
      meta: {layout: 'dashboard', permissions: ['browse_dossier'], allowAnonymous: false}
    },
    {
      path: '/dashboard/dossier/:id/factures',
      name: 'singleFolderFacture',
      component: singleFolderFacture,
      meta: {layout: 'dashboard', permissions: ['browse_dossier', 'browse_facture'], allowAnonymous: false}
    },
    {
      path: '/dashboard/database',
      name: 'database',
      component: databaseListing,
      meta: {layout: 'dashboard',permissions: ['browse_database'], allowAnonymous: false}
    },
    {
      path: '/dashboard/account',
      name: 'myProfile',
      component: myProfile,
      meta: {layout: 'dashboard', permissions: [], allowAnonymous: false}
    },
    {
      path: '/dashboard/users',
      name: 'usersListing',
      component: usersListing,
      meta: {layout: 'dashboard', permissions: ['browse_users', 'add_user', 'edit_user', 'delete_user'], allowAnonymous: false}
    },
    {
      path: '/dashboard/users/privilege',
      name: 'usersPrivilege',
      component: usersPrivilege,
      meta: {layout: 'dashboard', permissions: ['browse_users', 'add_user', 'edit_user', 'delete_user'], allowAnonymous: false}
    },
    {
      path: '/dashboard/settings',
      name: 'settings',
      component: settings,
      meta: {layout: 'dashboard', permissions: [], allowAnonymous: false}
    },
    {
      path: '/dashboard/logs',
      name: 'logs',
      component: settings,
      meta: {layout: 'dashboard', permissions: [], allowAnonymous: false}
    },
    {
      path: '/dashboard/website',
      name: 'websiteSettings',
      component: websiteSettings,
      meta: {layout: 'default', permissions: ['website_edit'], allowAnonymous: false}
    },
    {
      path: '/dashboard/statistics',
      name: 'statistics',
      component: statistics,
      meta: {layout: 'dashboard',permissions: ['statistique'], allowAnonymous: false}
    },
    {
      path: '/dashboard/login',
      name: 'dashboardLogin',
      component: dashboardLogin,
      meta: {layout: 'dashboard-login', allowAnonymous: true}
    },
    {
      path: '/dashboard/login/reset',
      name: 'resetLogin',
      component: resetLogin,
      meta: {layout: 'dashboard-login', allowAnonymous: true}
    },
    {
      path: '/dashboard/user/:email/reset_password/:reset_code',
      name: 'checkResetLogin',
      component: checkResetLogin,
      meta: {layout: 'dashboard-login', allowAnonymous: true}
    },
    {
      path: '*',
      name: 'catchAll',
      component: comingSoon,
      meta: { layout: 'default', allowAnonymous: true }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js